import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ProtocolDetModel } from '../models/ProtocolDetModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class ProtocolDetService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getProtocolDetCat(prHdCode: string , prDetCategory: string) {
      let params = new HttpParams();
        params = params.append("PrHdCode", prHdCode);
        params = params.append("PrDetCategory", prDetCategory);
        const options = {
          params: params
      };
      return this.http.get<ProtocolDetModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/ProtocolDet/GetProtocolDetCat',options);
    }
    public getProtocolDetCatSup(prHdCode: string , prDetCategory: string) {

      let params = new HttpParams();
        params = params.append("PrHdCode", prHdCode);
        params = params.append("PrDetCategory", prDetCategory);

        const options = {
          params: params
      };
      return this.http.get<ProtocolDetModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/ProtocolDet/GetProtocolDetCatSup',options);
    }

    public AddProtocolDetCat(protocolDet: ProtocolDetModel) {
      return this.http.post<ProtocolDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/ProtocolDet/AddProtocolDet_Cat', protocolDet);
    }
    public AddProtocolDetCatNew(protocolDet: ProtocolDetModel) {
      return this.http.post<ProtocolDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/ProtocolDet/AddProtocolDet_CatNew', protocolDet);
    }

    public delProtocolDetCat(prHdCode: string , prDetCategory: string ,prDetItCode:string, prDetStep: string) {

    let params = new HttpParams();
      params = params.append("prHdCode", prHdCode);
      params = params.append("PrDetCategory", prDetCategory);
      params = params.append("prDetItCode", prDetItCode);
      params = params.append("PrDetStep", prDetStep);


      const options = {
        params: params
    };
    return this.http.get<ProtocolDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/ProtocolDet/DeleteiProtocolDetCat',options);
    }

   public delProtocolDetCatSup(prHdCode: string , prDetCategory: string ,prDetItCode:string,prDetStep:string ) {

  let params = new HttpParams();
    params = params.append("prHdCode", prHdCode);
    params = params.append("PrDetCategory",prDetCategory);
    params = params.append("prDetItCode", prDetItCode);
    params = params.append("prDetStep", prDetStep);

    const options = {
      params: params
  };
  return this.http.get<ProtocolDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/ProtocolDet/DeleteiProtocolDetCatSup',options);
  }

  public delProtocolDetAll(prHdCode: string ) {

  let params = new HttpParams();
    params = params.append("prHdCode", prHdCode);

    const options = {
      params: params
  };
  return this.http.get<ProtocolDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/ProtocolDet/DeleteiProtocolDet',options);
}

  }
